import styled from '@emotion/styled'
import { Box, Icon, ListItemIcon } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

import { ListItem, ListItemText } from '@material-ui/core'

export const ChartListMenuIcon = styled(Icon)`
  color: ${colors.copy.paragraphDark};
  min-width: 0 !important;
`

export const ChartMenuItemContainer = styled(Box)`
  color: ${colors.copy.paragraphDark};
  cursor: pointer;
  font-size: 16px;
  height: auto;
`

export const ChartMenuItemIcon = styled(ListItemIcon)`
  color: ${colors.interactive.primaryEnabled};
  width: 32px;
  min-width: 0 !important;
`

export const ChartMenuListItem = styled(ListItem)`
  align-items: center;
  display: flex;
  padding-right: 16px;
  justify-content: space-between;
`

export const ChartMenuItemText = styled(ListItemText)`
  font-size: 16px;
`

export const FlexRow = styled.div`
  display: flex;
  gap: 24px;
`

export const ChartModalSubHeader = styled.div`
  ${typography.baseline.semiBoldSans};
  align-items: center;
  display: flex;
`

export const ChartModalButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
`

export const DeleteChartContentContainer = styled.div`
  align-items: center;
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
  padding: 20px;
  width: 768px;
`

export const FlexRowColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`

export const Text = styled.div`
  ${typography.baseline.regularSans};
`
export const ChartModalHeader = styled.div`
  ${typography.up2.semiBoldSans};
`
